import { useEffect } from "react";
import { useSelector } from "react-redux";

import { MoreHoriz } from "@livechat/design-system-icons";
import { ActionMenu, Icon, Loader } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { SettingsSection } from "constants/settings/sections";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { useDisconnectOpenWidget } from "hooks/settings/openwidget/use-disconnect-openwidget";
import { OpenWidgetState, useOpenWidgetState } from "hooks/settings/openwidget/use-openwidget-state";
import useSettingsSection from "hooks/settings/use-settings-section";
import { selectIsAdmin } from "store/entities/agents";
import { selectIsOpenWidgetConnected, selectOpenWidgetId } from "store/entities/integrations";

import SettingsViewContainer from "../ViewContainer";

import { Connected } from "./Connected";
import { NotConnected } from "./NotConnected";
import { NotInOrganization } from "./NotInOrganization";
import { loaderStyles, overflowAutoStyles } from "./styles";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const OpenWidget = () => {
  useSettingsSection(SettingsSection.OpenWidget);
  const { data, isLoading } = useOpenWidgetState();
  const { mutate: disconnectOpenWidget } = useDisconnectOpenWidget();
  const integrationId = useSelector(selectOpenWidgetId);
  const isOpenWidgetConnected = useSelector(selectIsOpenWidgetConnected);
  const isOwner = useSelector(selectIsAdmin);
  const shouldSeeDisconnectMenu = isOpenWidgetConnected && isOwner;

  useEffect(() => {
    trackEngagement("Settings: OpenWidget section opened", EventPlace.Settings);
  }, []);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onDisconnectOpenWidget = () => {
    if (integrationId) {
      disconnectOpenWidget(integrationId);
      trackEngagement("OpenWidget: Disconnected", EventPlace.Settings);
    }
  };

  return (
    <SettingsViewContainer
      title="Contact widget"
      contentCss={overflowAutoStyles}
      rightNodes={
        shouldSeeDisconnectMenu && (
          <Block marginRight="1rem">
            <ActionMenu
              options={[{ onClick: onDisconnectOpenWidget, key: "disconnect", element: "Disconnect" }]}
              triggerRenderer={<Icon source={MoreHoriz} />}
            />
          </Block>
        )
      }
    >
      {isLoading ? (
        <Loader size="large" css={loaderStyles} />
      ) : (
        <>
          {data?.state === OpenWidgetState.NotInOrganization && <NotInOrganization />}
          {data?.state === OpenWidgetState.Unconnected && <NotConnected />}
          {(data?.state === OpenWidgetState.Connected || data?.state === OpenWidgetState.Installed) && (
            <Connected snippetCode={data.snippetCode} installed={data.state === OpenWidgetState.Installed} />
          )}
        </>
      )}
    </SettingsViewContainer>
  );
};
